import debounce from 'lodash/debounce';
import { EventToolbox } from 'client/utils/event-toolbox';

const lineItemIdsStorage = [];
const adNamesStorage = [];
const creativeIdsStorage = [];
const adTrackingDebounceTimer = 250;

const emptyStorage = () => {
  lineItemIdsStorage.length = 0;
  adNamesStorage.length = 0;
  creativeIdsStorage.length = 0;
};

export const fireDefaultEvent = debounce(() => {
  EventToolbox.fireTrackAction({
    event_type: 'action_completed',
    event_data: {
      action_category: 'system',
      action_name: 'ad_load',
      value: adNamesStorage.join(','),
      action_cause: 'action_completed',
      line_item_id: lineItemIdsStorage.join(','),
      creative_id: creativeIdsStorage.join(','),
    },
  });
  emptyStorage();
}, adTrackingDebounceTimer);

export const fireHeavyAdInterventionEvent = debounce((lineItemId, messageText) => {
  EventToolbox.fireTrackAction({
    event_type: 'action_completed',
    event_data: {
      action_category: 'system',
      action_name: 'show_content',
      subaction_name: 'ad_unload',
      action_cause: messageText,
      value: lineItemId,
    },
  });
}, adTrackingDebounceTimer);

export const handleAdLoad = event => {
  const { resetLineItemIdsStorage, lineItemId, adName, slotId } = event;
  if (resetLineItemIdsStorage) {
    emptyStorage();
  }
  lineItemIdsStorage.push(lineItemId || '-1');
  adNamesStorage.push(adName.replace(/,/g, '/'));
  creativeIdsStorage.push(slotId);
  fireDefaultEvent(adName, slotId);
};
